import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppointmentInvoiceTransactionStatus, PatientAppointmentBill } from 'src/app/entities/appointment-bill.entity';
import { PatientAppointment } from 'src/app/entities/appointment.entity/patient-appointment.entity/patient-appointment';
import { User } from 'src/app/entities/user.entity';
import { Currency } from 'src/app/modules/patient.module/patient-dashboard.module/patient-appointments.module/patient-appointment-bill.module/appointment-bill-card.component/appointment-bill-card.component';
import { AuthService } from 'src/app/services/auth.service/auth.service';
import { KonnectPaymentService } from 'src/app/services/konnect-payment.service/konnect-payment.service';
import { Language } from 'src/app/services/localization.service/localization.service';
import { PatientAppointmentsService } from 'src/app/services/patient-appointments.service/patient-appointments.service';
import { PaymeService } from 'src/app/services/payme.service/payme.service';
import { PaymentTransactionsService } from 'src/app/services/payment-transactions.service/payment-transactions.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-appointment-booking-payment',
  templateUrl: './appointment-booking-payment.component.html',
  styleUrls: ['./appointment-booking-payment.component.css']
})
export class AppointmentBookingPaymentComponent implements OnInit {
  @Output() paymentComplete: EventEmitter<boolean> = new EventEmitter();
  @Output() transactionRequested: EventEmitter<Currency> = new EventEmitter();

  @Input() patientAppointment: PatientAppointment = new PatientAppointment();
  patientAppointmentBill: PatientAppointmentBill = new PatientAppointmentBill();
  payMeUrl!: SafeResourceUrl;
  currency: Currency = 'TND';
  @Input() language: string = "fr"
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public sanitizer: DomSanitizer,
    private patientAppointmentsService: PatientAppointmentsService,
    private paymentTransactionsService: PaymentTransactionsService
  ) { }

  @HostListener('window:message', ['$event']) onMessage(event) {
    if (event.data === '_payment-success_')
      this.completePayment(AppointmentInvoiceTransactionStatus.COMPLETED);
    if (event.data === '_payment-failed_')
      this.completePayment(AppointmentInvoiceTransactionStatus.PENDING);
  }

  completePayment(status: AppointmentInvoiceTransactionStatus): void {
    this.paymentComplete.emit(
      status == AppointmentInvoiceTransactionStatus.COMPLETED
    );
  }

  ngOnInit(): void {
    this.patientAppointmentsService
      .billByConfidentialNologCode(this.patientAppointment.id)
      .subscribe((res) => {
        this.patientAppointmentBill = PatientAppointmentBill.fromResponse(res);
      });

    this.paymentComplete.subscribe((isCompleted) => {
      if (isCompleted) this.router.navigate(['patient', 'appointments']);
    });
  }

  onCreateTransaction(currency: Currency): void {
    this.paymentTransactionsService
      .createTransactionNoLog(this.patientAppointmentBill!.id, "TND")
      .subscribe((transaction) => {
        this.payMeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          transaction.url
        );
      });
  }


  // ------



  onCurrencyChange(currency: any): void {
    this.currency = currency;
  }

  get isPaid(): boolean {
    return this.patientAppointment.isPaid;
  }


  getConvertedTotalAmount(): number {
    if (this.currency == 'USD') {
      return this.patientAppointmentBill.totalAmountUSD;
    } else if (this.currency == 'EUR') {
      return this.patientAppointmentBill.totalAmountEUR
    } else return this.patientAppointmentBill.totalAmountTND;
  }
}